import { ViewableDate } from "../../models/ViewableDate";
import { getLockedModels } from "../../services/locks/ModelLocks";
import { useSmartTimer } from "../hooks/useSmartTimer";
import { LockState, useModelLockDispatch } from "./contexts/GoodLockProvider";

export { ModelLockInfoTimer };

type Props = {
  batchClassId: string;
  intervalMs: number;
  debug?: boolean;
};
const ModelLockInfoTimer = (props: Props) => {
  const lockDispatch = useModelLockDispatch();

  const [lastUpdated] = useSmartTimer(
    async (batchClassId) => await getLockedModels(batchClassId),
    props.intervalMs,
    (models) => {
      const newLocks = models.reduce((prev, curr) => {
        prev[curr.checkedOutId] = [
          curr.createdBy,
          props.batchClassId,
          curr.parent == null || curr.parent == undefined,
        ];
        return prev;
      }, {} as LockState);

      lockDispatch({
        data: newLocks,
        type: "set",
      });
    },
    [props.batchClassId],
  );

  if (props.debug) {
    return (
      <span
        style={{
          display: "flex",
          flexGrow: 1,
          justifyContent: "center",
          padding: "1rem",
        }}
      >
        Last Updated:{" "}
        {lastUpdated == null
          ? "Not Synced Yet"
          : ViewableDate(lastUpdated, true)}
      </span>
    );
  } else {
    return null;
  }
};
